import React, { useRef, useState } from 'react'
import type { Swiper as SwiperType } from 'swiper'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react'

import { useAppDispatch, useAppSelector } from '@/core/store'
// import { setGotTutorial } from '@/core/store/catalog.store'
import { closeFullImageView } from '@/core/store/ui.store'
import { setFullImageView } from '@/core/store/ui.store'

import { IconClose } from '../Ui/Icons'

export const FullScreenImage = () => {
  // point location = public/api/en/short/points.json
  const { fullImageView } = useAppSelector((store) => store.uiState)
  const [activeIndex, setActiveIndex] = useState(0)
  const dispatch = useAppDispatch()
  return (
    <>
      <div className={'full-screen-image-background' + (fullImageView ? ' active' : '')}></div>
      <div className={'full-screen-image' + (fullImageView ? ' active' : '')}>
        <div className="close-full-screen" onClick={() => dispatch(closeFullImageView())}>
          <IconClose white={true} />
        </div>

        {/* Одиночное изображение */}
        {fullImageView?.gallery && fullImageView.gallery.length <= 1 && (
          <div className="full-screen-image-container">
            <div className="image-container">
              <img src={fullImageView?.gallery[0].uri} alt="" />
              {fullImageView?.gallery[0]?.copyright && (
                <div className="image-copyright">{fullImageView.gallery[0].copyright}</div>
              )}
            </div>
            {fullImageView?.gallery[0]?.caption && (
              <div className="image-description">{fullImageView.gallery[0].caption}</div>
            )}
          </div>
        )}

        {/* Галерея */}
        {fullImageView?.gallery && fullImageView.gallery.length > 1 && (
          <div className="full-screen-image-container">
            <div className="swiper-container-gallery">
              <Swiper
                spaceBetween={30}
                slidesPerView={1}
                modules={[Navigation]}
                navigation={{
                  prevEl: '.swiper-button-prev',
                  nextEl: '.swiper-button-next',
                }}
                onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                className="swiper-wrapper-custom"
              >
                {fullImageView?.gallery.map((img, idx) => (
                  <SwiperSlide key={idx}>
                    <div className="image-container">
                      <img className="object__photo__swiper" src={img.uri} alt="" />
                      {img?.copyright && (
                        <div className="image-copyright">{img.copyright}</div>
                      )}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
            </div>

            {fullImageView?.gallery[activeIndex]?.caption && (
              <div className="image-description">{fullImageView.gallery[activeIndex].caption}</div>
            )}
          </div>
        )}
      </div>
    </>
  )
}
